import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { OtpInputComponent } from '../otp-input/otp-input.component';

export interface Dialog2faCodeData {
    /** Set when re-prompting after a rejected code. */
    error?: boolean;
}

@Component({
    selector: 'app-dialog-2fa-code',
    standalone: true,
    imports: [FormsModule, MatDialogModule, MatButtonModule, MatIconModule, OtpInputComponent],
    templateUrl: './dialog-2fa-code.component.html',
    styleUrl: './dialog-2fa-code.component.scss',
})
export class Dialog2faCodeComponent {
    private readonly _ref = inject(MatDialogRef<Dialog2faCodeComponent, string | null>);
    readonly data = inject<Dialog2faCodeData>(MAT_DIALOG_DATA, { optional: true }) ?? {};

    code = '';

    onComplete(code: string): void {
        this._ref.close(code);
    }

    confirm(): void {
        if (this.code.length === 6) this._ref.close(this.code);
    }

    cancel(): void {
        this._ref.close(null);
    }
}
